module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/public/login/logout/logout.component.scss
// module id = ./src/app/pages/public/login/logout/logout.component.scss
// module chunks = main